import React from "react";
import img1 from "../../assets/Armis.png";
// Import the new CSS file (make sure to create it)
import "./Armis.css";

export const Summary = () => {
  return (
    <section className="armis-container">
      <div className="armis-image-wrapper">
        <img src={img1} alt="Armis IoT Security Platform illustration" />
      </div>
      <div className="armis-content">
        <h2>Armis: Unified Asset Intelligence</h2>
        <p className="armis-lead">
          Armis is a cybersecurity platform specializing in <strong>IoT and unmanaged device security</strong>.
        </p>
        <p>
          It automatically discovers, analyzes, and protects every connected network device, minimizing risks associated with unmanaged or vulnerable assets that traditional security tools miss.
        </p>
        <p>
          Armis provides <strong>real-time visibility</strong> and <strong>threat detection</strong>, securing enterprise networks from potential threats arising from the proliferation of devices in modern business environments.
        </p>
      </div>
    </section>
  );
};